import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import './index.css';
import App from './App';
import 'react-multi-carousel/lib/styles.css';



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);